import type { TourRequest } from '../Types/Tours.types';

export const toursQueryKeys = {
  all: ['tours'] as const,
  lists: () => [...toursQueryKeys.all, 'list'] as const,
  list: (params: TourRequest) => [...toursQueryKeys.lists(), params] as const,
  details: () => [...toursQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...toursQueryKeys.details(), id] as const,
  stats: (id: string) => [...toursQueryKeys.all, 'stats', id] as const,
};
